import { render, staticRenderFns } from "./ChordRoll.vue?vue&type=template&id=12d77333&scoped=true"
import script from "./ChordRoll.vue?vue&type=script&lang=js"
export * from "./ChordRoll.vue?vue&type=script&lang=js"
import style0 from "./ChordRoll.vue?vue&type=style&index=0&id=12d77333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d77333",
  null
  
)

export default component.exports